import React from "react";
import { useSelector } from "react-redux";

import SearchDropdown from "@cayuse/shared-react.components.search-dropdown";

import IconButton from "@cayuse/shared-react.components.icon-button";

import { CAYUSE_TYPES, IS_DEV, IS_ENG, IS_FT } from "globals/constants";
import { useDictionary } from "hooks";
import { tenantSelectors } from "store/selectors";

import { QuestionFooter, QuestionHeader } from "../Question";
import styles from "./styles.css";


export function FundingProgramComponent ({ completeFormModel, config, onChange, onDelete }) {
	const fundingSchemeDictionary = useSelector(tenantSelectors.useFundingSchemeDictionary);
	const dictionary = useDictionary(`simplifiedBuilder.components.${fundingSchemeDictionary ? "fundingScheme" : "fundingProgram"}`);

	const onChangeConfig = newProps => onChange(prev => ({ ...prev, ...newProps }));

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig} />

			<hr className={styles.dividingLine}/>

			<div className={styles.block}>
				<div className={`ui input ${styles.input}`}>
					<label>
						<span>{dictionary.label} <span className={styles.asterisk}>*</span></span>
					</label>
					<SearchDropdown
						disabled
						placeholder={dictionary.inputPlaceholder}
						selection
						className={styles.searchFundingProgram}
						fieldLabel={`${dictionary.label} required.`}
					/>
				</div>
				<table className={`ui table ${styles.table}`}>
					<thead>
						<tr>
							<th>{dictionary.tableColumns[0]}</th>
							<th style={{ width: 100 }}>{dictionary.tableColumns[1]}</th>
							<th>{dictionary.tableColumns[2]}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td colSpan="3">{dictionary.emptyTable}</td>
						</tr>
					</tbody>
				</table>

				<div>
					<IconButton icon="plus" disabled primary labelPosition="left">
						{dictionary.addItemButton}
					</IconButton>
				</div>
			</div>

			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			/>
		</>
	);
}

FundingProgramComponent.showInPalette = () => true;

FundingProgramComponent.paletteInformation = () => ({
	id: "fundingProgram",
	name: tenantSelectors.useFundingSchemeDictionary() ? "Funding Scheme" : "Funding Program",
	type: "fundingProgram",
	group: "sponsoredProject",
	editableLabel: true,
});

FundingProgramComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-funding-program",
		customStencilId: "null"
	},
	type: "fundingProgram",
	cayuseType: CAYUSE_TYPES.FUNDING_PROGRAM,
	cayuseShortLabel: "other",
	cayuseShortLabel2: "",
});

FundingProgramComponent.initialValue = "";
